module.exports = __webpack_public_path__ + "01_long_black.f1cf73d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_long_black.png
// module id = Hj/D
// module chunks = 0